module.exports = __webpack_public_path__ + "img/logo_top.0473d898.png";